import React, { lazy, useState, useEffect, Suspense } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { useContextHook } from 'use-context-hook';
import pages from '../nav.json';
import { AuthContext } from '../Context/authContext';
import Toast from '../components/Toast';
import Loaders from '../components/Loaders';
import Layout from '../components/Layout';

const importView = file => {
  return lazy(() =>
    import(`./${file}`).catch(() => {
      Toast({
        type: 'error',
        message: `Error in importing ${file}`,
      });
    }),
  );
};

export default function Index() {
  const { loading_user, user } = useContextHook(AuthContext, ['loading_user', 'user']);

  function isEmpty(obj) {
    return obj && Object.keys(obj).length === 0 && obj.constructor === Object;
  }
  const history = useNavigate();
  const location = useLocation();

  const { view } = useParams();
  const metaViewData = pages;
  const [selectedView, setSelectedView] = useState([]);

  async function loadView(filtered) {
    const promise = filtered.map(async _view => {
      const View = await importView(_view?.file);

      // eslint-disable-next-line no-use-before-define
      return <View key={_view?.id} selectView={selectView} />;
    });
    Promise.all(promise).then(setSelectedView);
  }

  async function selectView(file) {
    const filtered = metaViewData.filter(elem => elem.file === file);

    loadView([filtered[0]]);
  }

  useEffect(() => {
    let fileToLoad = view;

    // Preserve any query string (e.g. /events-catalog?genre=rock) so deep-links
    // can pre-fill filters on the target screen.
    history({ pathname: `/${fileToLoad}`, search: location.search }, { replace: true });

    selectView(fileToLoad);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [view, loading_user]);

  return loading_user || isEmpty(user) ? (
    <Loaders viewLoader />
  ) : (
    <Layout showTemplate={metaViewData?.filter(elem => elem.file === view)[0]?.navigations} user={user}>
      <Suspense fallback={<Loaders viewLoader />}>{selectedView}</Suspense>
    </Layout>
  );
}
